import { Row, Col } from 'react-bootstrap';
import { Label } from 'ypf-pas-general-ui-components';
import PropTypes from 'prop-types';

import { workReportLineStatus } from '../../../../utils/dataStatus';
import { Line } from '../../../../utils/globalPropTypes';

const ProgramPointTableHeader = ({ line, dailyView, displayButtons, viewCSA, isExtentedView }) => {
  const isLineFixedStatus = line?.estadoEnum === workReportLineStatus.fijar;

  const getMarginLeft = () => {
    if (displayButtons) return '70px';
    if (isLineFixedStatus && dailyView) return '0px';

    return '25px';
  };

  return (
    <Row>
      <Col sm={2} style={{ marginLeft: '5px' }}>
        <Label
          className="d-flex"
          label={`Cantidad ${' '} [${line?.unidadMedida}]`}
          size="md"
          sizeValue="md"
        />
      </Col>
      <Col sm={1} style={{ marginRight: '15px' }}>
        <Label label="P. Prog." size="md" sizeValue="md" />
      </Col>
      {viewCSA && (
        <>
          <Col
            sm={2}
            style={{
              marginLeft: getMarginLeft()
            }}
          >
            <Label label="Clas. C /F. Op." size="md" sizeValue="md" />
          </Col>
          {!isExtentedView && (
            <Col sm={1} style={{ marginLeft: '0px' }}>
              <Label label="Clasificacion" size="md" sizeValue="sm" />
            </Col>
          )}
          <Col sm={1} style={{ marginLeft: !isExtentedView ? '30px' : '15px' }}>
            <Label label="Cod. C." size="md" sizeValue="sm" />
          </Col>
          <Col sm={1} style={{ marginLeft: '15px' }}>
            <Label label="Subcodigo" size="md" sizeValue="sm" />
          </Col>
          <Col style={{ marginLeft: '25px' }}>
            <Label label="Descripción" size="md" sizeValue="sm" />
          </Col>
        </>
      )}
    </Row>
  );
};

ProgramPointTableHeader.propTypes = {
  line: Line.isRequired,
  dailyView: PropTypes.bool,
  displayButtons: PropTypes.bool,
  viewCSA: PropTypes.bool,
  isExtentedView: PropTypes.bool
};

ProgramPointTableHeader.defaultProps = {
  dailyView: false,
  displayButtons: false,
  viewCSA: false,
  isExtentedView: false
};
export default ProgramPointTableHeader;
